import { createStructuredSelector } from 'reselect';
import {
    COM_AREA_LIST, COM_AREA_LIST_SUCCESS, COM_AREA_LIST_ERROR,
    COM_AREA_PAGE_SET, COM_AREA_SEARCH_CHANGE,
    COM_AREA_ADD_MODAL_SET, COM_AREA_ADD_CHANGE,
    COM_AREA_ADD, COM_AREA_ADD_SUCCESS, COM_AREA_ADD_ERROR,
    COM_AREA_EDIT_MODAL_SET, COM_AREA_EDIT_SET_DATA,
    COM_AREA_UPDATE, COM_AREA_UPDATE_SUCCESS, COM_AREA_UPDATE_ERROR,
    COM_AREA_CANCEL_MODAL_SET, COM_AREA_CANCEL_SET_DATA,
} from '../../actions';

export const NAME = 'comArea';

export const ComAreaList = (page, num_page, orderBy, filters) => ({ type: COM_AREA_LIST, payload: { page, num_page, orderBy, filters } });
export const ComAreaListSuccess = (data) => ({ type: COM_AREA_LIST_SUCCESS, payload: data });
export const ComAreaListError = (error) => ({ type: COM_AREA_LIST_ERROR, payload: error });
export const ComAreaPageSet = (data) => ({ type: COM_AREA_PAGE_SET, payload: data });
export const ComAreaSearchChange = (data) => ({ type: COM_AREA_SEARCH_CHANGE, payload: data });

export const ComAreaAddModalSet = (data) => ({ type: COM_AREA_ADD_MODAL_SET, payload: data });
export const ComAreaAddChangeSet = (data) => ({ type: COM_AREA_ADD_CHANGE, payload: data });
export const ComAreaAdd = (data) => ({ type: COM_AREA_ADD, payload: data });
export const ComAreaAddSuccess = (data) => ({ type: COM_AREA_ADD_SUCCESS, payload: data });
export const ComAreaAddError = (error) => ({ type: COM_AREA_ADD_ERROR, payload: error });

export const ComAreaEditModalSet = (data) => ({ type: COM_AREA_EDIT_MODAL_SET, payload: data });
export const ComAreaEditSetData = (data) => ({ type: COM_AREA_EDIT_SET_DATA, payload: data });
export const ComAreaUpdate = (data) => ({ type: COM_AREA_UPDATE, payload: data });
export const ComAreaUpdateSuccess = (data) => ({ type: COM_AREA_UPDATE_SUCCESS, payload: data });
export const ComAreaUpdateError = (error) => ({ type: COM_AREA_UPDATE_ERROR, payload: error });

export const ComAreaCancelModalSet = (data) => ({ type: COM_AREA_CANCEL_MODAL_SET, payload: data });
export const ComAreaCancelSetData = (data) => ({ type: COM_AREA_CANCEL_SET_DATA, payload: data });

const comArea = (state) => state[NAME];
export const ComAreaSelector = createStructuredSelector({ comArea });
